import * as z from '@exact-magic/validation';

export const ChangePassword = z.object({
  current: z.password(),
  new: z.password(),
});
export type ChangePassword = z.input<typeof ChangePassword>;
